import React, { forwardRef } from 'react';

const HappySmileyIcon = forwardRef(({ height, width }, ref) => (
    <svg x="0px" y="0px" viewBox="0 0 42 42" width={width} height={height} ref={ref}>
        <g>
            <circle style={{ fill: '#FBD971' }} cx="21" cy="21" r="21" />
            <circle style={{ fill: '#AF8066' }} cx="13.5" cy="13.5" r="3.5" />
            <circle style={{ fill: '#AF8066' }} cx="29.5" cy="13.5" r="3.5" />
            <path style={{ fill: '#C03A2B' }} d="M32,24c0,6.075-4.925,11-11,11s-11-4.925-11-11H32z" />
        </g>
    </svg>
));

HappySmileyIcon.displayName = 'HappySmileyIcon';

export default HappySmileyIcon;
